import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'listo-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent {
  @Input() name = '';
  @Input() label: string;
  @Input() autofocus = false;
  @Input() required = false;
  @Input() loading = false;
  @Input() type?: string;
  @Input() form = new FormControl();
  @Input() placeholder?: string = '';
  @Input() mask?: any = false;

  focus = false;

  get pending() {
    const control = this.form.get(this.name);
    return (control && control.pending) || this.loading;
  }

  get error() {
    const control = this.form.get(this.name);
    if (!control || control.untouched || !control.errors) {
      return;
    }
    const type = Object.keys(control.errors)[0];
    return {
      type,
      value: control.errors[type],
    };
  }
}
